import { storeResources } from './resources';

import authReducer from './auth';
import userReducer from './user';
import ticketsSlice from './tickets';
import errorsSlice from './errors';
import configSlice from './config';
import chatsSlice from './chats';
import invoicesSlice from './invoices';
import notificationsSlice from './notifications';
import verificationRequestSlice from './verificationRequest';
import ticketTemplates from './ticketTemplates';
import tableSlice from './table';
import themeModeSlice from './themeMode';
import uiModeSlice from './uiMode';

const combinedReducer = {
  [storeResources.AUTH]: authReducer,
  [storeResources.USER]: userReducer,
  [storeResources.TICKETS]: ticketsSlice,
  [storeResources.ERRORS]: errorsSlice,
  [storeResources.CONFIG]: configSlice,
  [storeResources.CHATS]: chatsSlice,
  [storeResources.INVOICES]: invoicesSlice,
  [storeResources.NOTIFICATIONS]: notificationsSlice,
  [storeResources.VERIFICATION_REQUEST]: verificationRequestSlice,
  [storeResources.TICKET_TEMPLATES]: ticketTemplates,
  table: tableSlice,
  [storeResources.THEME_MODE]: themeModeSlice,
  [storeResources.UI_MODE]: uiModeSlice,
};

export default combinedReducer;
